"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.avatarSizeOptions = exports.BaseAvatar = exports.Avatar = exports.AVATAR_SIZE = exports.AVATAR_COLOR = void 0;
var React = _interopRequireWildcard(require("react"));
var _Text = require("../../components/Text");
var _color = require("../../styles/variables/_color");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Icon = require("../Icon");
var _StatusIndicator = require("../StatusIndicator");
var _AvatarModule = _interopRequireDefault(require("./Avatar.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AVATAR_SIZE = exports.AVATAR_SIZE = Object.freeze({
  small: 'small',
  medium: 'medium',
  large: 'large',
  extraLarge: 'extraLarge'
});
const avatarSizeOptions = exports.avatarSizeOptions = [...Object.keys(AVATAR_SIZE)];
const AVATAR_COLOR = exports.AVATAR_COLOR = Object.freeze({
  red: _color.colorDangerLightest,
  orange: _color.colorWarningLightest,
  green: _color.colorSuccessLightest,
  blue: _color.colorInformationLightest,
  gray: _color.colorGrayLightest,
  indigo: _color.colorNeutralLightest
});
const getAvatarText = function () {
  let text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const [firstWord, secondWord] = text.split(' ');
  const firstChar = firstWord ? firstWord[0].toUpperCase() : '';
  const secondChar = secondWord ? secondWord[0].toUpperCase() : '';
  return firstChar + secondChar;
};
const AvatarTextDecorator = _ref => {
  let {
    avatarText,
    size,
    className
  } = _ref;
  switch (size) {
    case 'small':
      return /*#__PURE__*/React.createElement(_Text.SubTitleSmall, {
        className: className
      }, avatarText);
    case 'medium':
      return /*#__PURE__*/React.createElement(_Text.SubTitleMedium, {
        className: className
      }, avatarText);
    case 'large':
      return /*#__PURE__*/React.createElement(_Text.SubTitleLarge, {
        className: className
      }, avatarText);
    case 'extraLarge':
      return /*#__PURE__*/React.createElement(_Text.JumboSmall, {
        className: className
      }, avatarText);
  }
};

// mapping of iconSize for each avatar size;
const iconSize = Object.freeze({
  small: 'small',
  medium: 'medium',
  large: 'medium',
  extraLarge: 'large'
});
const AvatarConditionalContent = _ref2 => {
  let {
    imageSrc,
    text,
    iconName,
    size,
    iconType,
    color = 'blue',
    status,
    statusBorderColorToken,
    classNames
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_AvatarModule.default.innerContainer, {
      [_AvatarModule.default.alignCenter]: !imageSrc
    }, classNames?.content),
    style: {
      '--background-color': AVATAR_COLOR[color]
    }
  }, !!status && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_AvatarModule.default.statusIndicatorWrapper, _AvatarModule.default[size])
  }, /*#__PURE__*/React.createElement(_StatusIndicator.StatusIndicator, {
    status: status,
    withBorder: true,
    borderColorToken: statusBorderColorToken
  })), imageSrc ? /*#__PURE__*/React.createElement("img", {
    src: imageSrc,
    alt: "Avatar",
    className: (0, _classify.default)(_AvatarModule.default.avatar, classNames?.image)
  }) : iconName ? /*#__PURE__*/React.createElement(_Icon.Icon, {
    name: iconName,
    type: iconType
    // @ts-ignore - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<{ small: string; medium: string; large: string; extraLarge: string; }>'.
    ,
    size: iconSize[size],
    className: classNames?.icon
  }) : text ?
  /*#__PURE__*/
  // @ts-ignore - TS2786 - 'AvatarTextDecorator' cannot be used as a JSX component.
  React.createElement(AvatarTextDecorator, {
    avatarText: getAvatarText(text),
    size: size,
    className: classNames?.text
  }) : null);
};
const Avatar = exports.Avatar = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    classNames,
    size = AVATAR_SIZE.medium,
    imageSrc,
    text,
    style,
    iconName,
    iconType,
    color,
    ring = false,
    status,
    statusBorderColorToken
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_AvatarModule.default.container, {
      [_AvatarModule.default.extraLargeSize]: size === 'extraLarge',
      [_AvatarModule.default.largeSize]: size === 'large',
      [_AvatarModule.default.mediumSize]: size === 'medium',
      [_AvatarModule.default.smallSize]: size === 'small'
    }, classNames?.wrapper)
    // @ts-ignore - TS2322 - Type 'unknown' is not assignable to type 'CSSProperties | undefined'.
    ,
    style: style,
    ref: ref
  }, ring ? /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_AvatarModule.default.ring, classNames?.ring)
  }, /*#__PURE__*/React.createElement("div", {
    className: _AvatarModule.default.whiteCircle
  }, /*#__PURE__*/React.createElement(AvatarConditionalContent, {
    imageSrc: imageSrc,
    text: text,
    iconName: iconName,
    iconType: iconType,
    color: color,
    size: size,
    status: status,
    statusBorderColorToken: statusBorderColorToken,
    classNames: classNames
  }))) : /*#__PURE__*/React.createElement(AvatarConditionalContent, {
    imageSrc: imageSrc,
    text: text,
    iconName: iconName,
    iconType: iconType,
    color: color,
    size: size,
    status: status,
    statusBorderColorToken: statusBorderColorToken,
    classNames: classNames
  }));
});
const BaseAvatar = _ref4 => {
  let {
    classNames,
    size = AVATAR_SIZE.medium,
    text = '',
    style,
    color = 'blue'
  } = _ref4;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_AvatarModule.default.container, {
      [_AvatarModule.default.baseExtraLargeSize]: size === 'extraLarge',
      [_AvatarModule.default.baseLargeSize]: size === 'large',
      [_AvatarModule.default.baseMediumSize]: size === 'medium',
      [_AvatarModule.default.baseSmallSize]: size === 'small'
    }, classNames?.wrapper)
    // @ts-ignore - TS2698 - Spread types may only be created from object types.
    ,
    style: {
      ...style,
      background: AVATAR_COLOR[color]
    }
  }, /*#__PURE__*/React.createElement(AvatarTextDecorator, {
    avatarText: text,
    size: size,
    className: classNames?.text
  }));
};
exports.BaseAvatar = BaseAvatar;